module.exports = __webpack_public_path__ + "static/media/Parco dell acqua - PW Pink_DK Gold.469fa352.jpg";